export enum ModalPictureType {
  User = 1,
  Client = 2,
  Employee = 3
}
